// extracted by mini-css-extract-plugin
export default {"reactPlayer":"Player_reactPlayer__YpDtZ"};